import { statisDimension } from '../const'

export default {
	header: {
		pic: 'statistical-analysis',
		title: '用水记录',
	},
	filterArr: [
		{
			title: '统计维度',
			filterList: [
				{
					key: 'queryType',
					type: 'select',
					keyWord: '统计维度',
					needAll: false,
					required: true,
					clearable: false,
					options: statisDimension.useWaterRecord,
				},
			],
		},
		{
			title: '统计条件',
			filterList: [
				{
					key: 'orgCode',
					type: 'select',
					keyWord: '所属部门',
				},
				{
					key: 'waterRegionCode',
					type: 'tree-select',
					keyWord: '所属区域',
					showSearch: false,
					propsObj: {
						label: 'name',
						children: 'children',
						id: 'code',
					},
				},
				{
					key: 'deviceTypeId',
					type: 'select',
					keyWord: '设备类型',
				},
				{
					key: 'dateSection',
					type: 'date',
					keyWord: '建档日期',
					icon: 'icon-shijian',
					datePickerType: 'datetimerange',
					required: true,
				},
			],
		},
	],
	formRules: {
		dateSection: [
			{
				required: true,
				message: '请选择建档日期',
				trigger: '',
			},
		],
	},
	columns: [
		{
			key: 'userNo',
			name: '用户编号',
		},
		{
			key: 'userName',
			name: '用户名称',
		},
		{
			key: 'addressName',
			name: '地址',
		},
		{
			key: 'waterUsedVol',
			name: '用水量',
		},
		{
			key: 'realUsedVol',
			name: '综合用水量',
		},
		{
			key: 'startPositiveAccumulation',
			name: '起始正向读数',
		},
		{
			key: 'startNegativeAccumulation',
			name: '起始反向读数',
		},
		{
			key: 'endPositiveAccumulation',
			name: '截止正向读数',
		},
		{
			key: 'endNegativeAccumulation',
			name: '截止反向读数',
		},
	],
	columns1: [
		{
			key: 'userCount',
			name: '用水户数',
		},
		{
			key: 'sumAmount',
			name: '用水量',
		},
		{
			key: 'realUserCount',
			name: '实际用水户数',
		},
		{
			key: 'useRate',
			name: '使用率',
		},
		{
			key: 'avgAmount',
			name: '户均用水量',
		},
		{
			key: 'commUserCount',
			name: '通讯户数',
		},
		{
			key: 'commRate',
			name: '通讯率',
		},
	],
}
